export function capitaliseText(text: string | undefined): string | undefined {
  if (!text) return;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function stripProductTier(text: string | undefined): string | undefined {
  if (!text) return;
  return text.replace(/-(gold|silver|platinum)$/i, '');
}

export function formatAddress(address: string[] = []): string[] {
  const addressItems = (address ?? []).filter((v) => !!v && v !== '');

  return addressItems.map((v, index) => {
    if (index === addressItems.length - 1) return v;

    return v.split(' ').map(capitaliseText).join(' ');
  });
}

export function toTitleCase(str: string = '') {
  return str.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

export function addressFormatting(addressList: string[] = [], joinIntoAString = false) {
  let formattedList = addressList
    .filter((i) => i !== '' && !!i)
    .map((i, index, array) => (index === array.length - 1 ? i.toUpperCase() : toTitleCase(i)));

  if (joinIntoAString) {
    return formattedList.join(', ');
  }

  return formattedList;
}
